module.exports = {
    VALIDATION: {
        DEFAULT: 'Invalid value',
        REQUIRED: 'This is a required field, please fill it in',
        MAX_LENGTH: 'Maximum value length exceeded',
        MIN_LENGTH: "Minimum length is {{value}} symbols",
        EMAIL: 'Email is incorrect',
        PHONE: 'Phone value is incorrect',
        URL: 'Url is not valid',
        EMAIL_MATCH: 'The email confirmation does not match you email address',
        SHARE_OVERFLOW: 'The total share value cannot be greater than 100%',
        SHARE_LOW: 'The total share value cannot be less than 100%',
        MATCHES_NOT_FOUND: "No issue found",
    },
    AUTHORIZATION: {
        UNAUTHORIZED_TITLE: "Sorry, you don't have authorization...",
        UNAUTHORIZED_MESSAGE: "You don't have permission to perform the action. Contact your Administrator for more help"
    }
};


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/translate/translations/en/error.ts